<div class="cookie-banner" #bannerEl *ngIf="visible" role="dialog" aria-label="Cookie consent">
  <div class="cookie-banner__inner">
    <div class="cookie-banner__text">
      <strong>{{ isManaging ? 'Cookie Preferences' : 'We use cookies' }}</strong>

      <!-- GDPR sites: opt-in ask -->
      <p *ngIf="!isManaging && mode === 'gdpr'">
        We use Google Analytics to understand how visitors use this site. This involves placing cookies on your device.
        You can accept or decline non-essential cookies. Essential cookies (session management, security) are always active.
        See our <a href="#" (click)="$event.preventDefault(); openPrivacyPolicy()">Privacy Policy</a> for details.
      </p>

      <!-- Notice-mode sites: analytics is on by default; the opt-out works -->
      <p *ngIf="!isManaging && mode === 'notice'">
        We use Google Analytics cookies to understand how visitors use this site. You can opt out at any time —
        essential cookies (session management, security) stay active either way.
        See our <a href="#" (click)="$event.preventDefault(); openPrivacyPolicy()">Privacy Policy</a> for details.
      </p>

      <p *ngIf="isManaging">
        Analytics cookies are currently <strong>{{ hasConsented ? 'enabled' : 'disabled' }}</strong>.
        Essential cookies (session, security) are always active and cannot be disabled.
        See our <a href="#" (click)="$event.preventDefault(); openPrivacyPolicy()">Privacy Policy</a>.
      </p>
    </div>
    <div class="cookie-banner__actions">
      <button class="cookie-btn cookie-btn--decline" (click)="decline()" type="button"
              [style.display]="isManaging && !hasConsented ? 'none' : ''">
        {{ isManaging ? 'Withdraw Consent' : (mode === 'notice' ? 'Opt out' : 'Decline') }}
      </button>
      <button class="cookie-btn cookie-btn--accept" (click)="accept()" type="button"
              [style.display]="isManaging && hasConsented ? 'none' : ''">
        {{ isManaging ? 'Enable Analytics' : (mode === 'notice' ? 'Got it' : 'Accept') }}
      </button>
      <button class="cookie-btn cookie-btn--close" *ngIf="isManaging" (click)="visible = false; isManaging = false" type="button">
        Close
      </button>
    </div>
  </div>
</div>
